import { TableBody } from '@mui/material';
import { AncillaryHourModel } from '../../lib/models/AncillaryHourModel';
import AncillaryHourItem from './AncillaryHourItem';

export type AncillaryHoursListingProps = {
    data: AncillaryHourModel[];
    setSnackbarArgument: (action: string) => void;
    setShowSnackbar: (result: boolean) => void;
    setErrored: (result: boolean) => void;
    refreshPage: () => void;
    refreshHeaderData: () => void;
};

const AncillaryHoursListing = ({
    data,
    setSnackbarArgument,
    setShowSnackbar,
    setErrored,
    refreshPage,
    refreshHeaderData
}: AncillaryHoursListingProps) => {
    return (
        <TableBody>
            {data.map((item, index) => (
                <AncillaryHourItem
                    key={index}
                    item={item}
                    setSnackbarArgument={setSnackbarArgument}
                    setShowSnackbar={setShowSnackbar}
                    setErrored={setErrored}
                    refreshHeaderData={refreshHeaderData}
                    refreshPage={refreshPage}
                />
            ))}
        </TableBody>
    );
};

export default AncillaryHoursListing;
